import { createAsyncThunk } from '@reduxjs/toolkit';

import VerificationProcessApi from 'api/curo/VerificationProcessApi';
import { VerificationProcessActionType } from 'enums/curo/VerificationProcessActionType';
import rejectWithValueHelper from 'utils/rejectWithValueHelper';

export const createGetCurrentAccountThunk = (api: VerificationProcessApi) =>
  createAsyncThunk(VerificationProcessActionType.GetCurrentAccount, async (_, thunkApi) => {
    try {
      return await api.getCurrentAccount();
    } catch (error) {
      return rejectWithValueHelper(error as Error, thunkApi);
    }
  });
